import httpClient from './client'
import ENDPOINT from './endpoint'

export const getLink = (id: string) => httpClient.get(`${ENDPOINT.LINKSPLUS}/${ENDPOINT.TRANSACTIONS}/${id}`)
